import type { QuizPersistentState } from "../types";

export type { QuestionHistoryEntry, QuizPersistentState } from "../types";

export const QUIZ_SOURCE = "bottom_sheet";
export const QUIZ_DISC_CODE = "WBQNG";
export const STORAGE_KEY = "quizState";
export const EXPIRY_DAYS = 30;
export const QUIZ_VERSION = "v1";
export const QUIZ_STATE_CHANGE = "quiz-state-change";

export const DEFAULT_STATE: QuizPersistentState = {
  status: 0,
  quizVersion: QUIZ_VERSION,
  lastQuestion: 0,
  lastExplainer: undefined,
  lastSlideType: "question",
  startedAt: null,
  completedAt: null,
  questionHistory: [],
  explainersHistory: [],
  config: {},
  results: undefined,
};

export const INITO_TRACKS_EVERYTHING_IMAGES = [
    'https://cdn.inito.com/quiz/result/inito_tracks_everything_gif1.webp',
    'https://cdn.inito.com/quiz/result/inito_tracks_everything_gif2.webp',
    'https://cdn.inito.com/quiz/result/inito_tracks_everything_gif3.webp',
    'https://cdn.inito.com/quiz/result/inito_tracks_everything_gif4.webp',
  ] as const;

  export const SCROLL_MILESTONES = [15, 30, 50, 70, 90] as const;
